
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/[slug]",
      function () {
        return require("private-next-pages/users/[id]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[id]/[slug]"])
      });
    }
  